import HomeController from './home.controller';

export default {
    template: require('./home.tpl.html'),
    controller: HomeController
};
